import * as types from '@/store/types'
import Vue from 'vue'
export default {
    addModule(context, payload) {
        context.modules.push(payload)
    },
    loadModules(context, payload) {
        context.modules = payload
    },
    setModule: (context, payload) => {
        const index = context.modules.findIndex(item => item.id === payload.id)
        context.modules[index] = payload
    },
    changeBotIdModelDefault: (context, botId) => {
        context.modelDefault.bot_id = botId
    },
    loadModuleMethods(context, payload) {
        context.moduleMethods = {}
        Object.assign(context.moduleMethods, { main: payload })
        payload.forEach(function(item, i, arr) {
            let category = item.id.split('.')[0]

            if (!context.moduleMethods.hasOwnProperty(category)) {
                Vue.set(context.moduleMethods, category, [])
            }
            context.moduleMethods[category].push(item)
        })
    }
}
